import { Link } from 'react-router-dom';
import HeroBackground from './HeroBackground';
import HeroScrollRail from './HeroScrollRail';
import SiteHeroCtas, { PAGE_HERO_CONTAINER_CLASS, PAGE_HERO_EYEBROW_CLASS, PAGE_HERO_H1_CLASS, PAGE_HERO_BODY_CLASS, PAGE_HERO_CTA_ROW_CLASS } from './SiteHeroCtas';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import './PublicSupportLayout.css';

// Used only by Services and Resources. Approved pages keep their existing styles.
export function SupportHero({ content, testId, backPath, backLabel, targetId }) {
  const paragraphs = String(content.body || '').split(/\n{2,}/).filter(Boolean);
  const words = String(content.title || '').split(/\s+/).filter(Boolean);
  const split = Math.max(1, words.length - (words.length > 5 ? 3 : 1));
  return <section className="site-image-hero support-hero relative flex min-h-[100svh] items-center overflow-hidden" data-theme-surface="dark" data-testid={testId}>
    <HeroBackground imageUrl={content.imageUrl} imageAlt={content.imageAlt} />
    <div className="absolute inset-0 grain-overlay" aria-hidden="true" />
    <div data-hero-text-parallax="true" className={PAGE_HERO_CONTAINER_CLASS}>
      <div className="support-hero-copy" aria-busy={content.__loading || undefined}>
        {backPath && <Link className="support-back-link" to={backPath}>← {backLabel}</Link>}
        <p className={PAGE_HERO_EYEBROW_CLASS + ' visible'}>{content.eyebrow}</p>
        <h1 aria-label={content.title} className={PAGE_HERO_H1_CLASS + ' visible'}>{words.slice(0, split).join(' ')}{words.length > split && <> <em className="shimmer-text">{words.slice(split).join(' ')}</em></>}</h1>
        <div className={PAGE_HERO_BODY_CLASS + ' visible'}>{paragraphs.map((text, index) => <p key={index}>{text}</p>)}</div>
        <SiteHeroCtas content={content} className={PAGE_HERO_CTA_ROW_CLASS} />
      </div>
    </div>
    {targetId && <HeroScrollRail targetId={targetId} />}
  </section>;
}

export function SupportRail({ items, testId }) {
  const topics = items.filter(Boolean);
  return <div className="topic-rail overflow-hidden border-y border-ink/10 bg-canvas" data-testid={testId}>
    <div className="marquee-container"><div className="marquee-track">{[...topics, ...topics].map((item, index) => <span key={index} className="mx-6 font-body text-[10px] uppercase tracking-[0.32em] text-copy/42">{item}</span>)}</div></div>
  </div>;
}

export function SupportSection({ id, label, title, description, children, tint = false, className = '' }) {
  return <section id={id} className={`support-section${tint ? ' support-section--tint' : ''} ${className}`} aria-labelledby={id ? id + '-title' : undefined}>
    <div className="site-content-shell">
      {(label || title) && <header className="support-section-heading">
        <div><p className="support-label">{label}</p><h2 id={id ? id + '-title' : undefined}>{title}</h2></div>
        {description && <p>{description}</p>}
      </header>}
      {children}
    </div>
  </section>;
}

export function SupportList({ items, className = '' }) {
  return <ol className={'support-numbered-list ' + className}>{items.map((item, index) => <li key={index}>
    <span className="support-number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span><p>{item}</p>
  </li>)}</ol>;
}

export function SupportFaqs({ items, id = 'faq', title = 'Questions about the service.', testId }) {
  if (!items?.length) return null;
  return <SupportSection id={id} label="Questions" title={title} className="support-faq-section">
    <div data-testid={testId}><Accordion type="single" collapsible data-testid={testId ? testId + '-accordion' : undefined}>
      {items.map(([question, answer], index) => <AccordionItem key={index} value={id + '-' + index} data-testid={testId ? `${testId}-item-${index}` : undefined}>
        <AccordionTrigger className="support-faq-trigger"><span className="support-number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span><span>{question}</span></AccordionTrigger>
        <AccordionContent className="support-faq-answer">{answer}</AccordionContent>
      </AccordionItem>)}
    </Accordion></div>
  </SupportSection>;
}
